// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back{\n    cursor:pointer;\n    position: absolute;\n    top:18px;\n    padding:10px;\n    left:10px;\n    transition: 0.1s;\n}\n.back:hover{\n    background: #ccc;\n    border-radius: 50%;\n}\nbutton{\n    padding:20px 0;\n    background-color: #ccc;\n    color: #000\n}", ""]);
// Exports
module.exports = exports;
